import React from "react";
import type { SVGProps } from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsError = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path d="M22.4,7.6c-.6-1.3-1.4-2.5-2.4-3.6s-2.2-1.8-3.6-2.4c-1.4-.6-2.9-.9-4.4-.9s-3,.3-4.4.9c-1.3.6-2.6,1.4-3.6,2.4-1,1-1.9,2.2-2.4,3.6-.6,1.4-.9,2.9-.9,4.4s.3,3,.9,4.4c.6,1.3,1.4,2.6,2.4,3.6,1,1,2.2,1.8,3.6,2.4,1.4.6,2.9.9,4.4.9s3-.3,4.4-.9c1.3-.6,2.6-1.4,3.6-2.4s1.9-2.2,2.4-3.6c.6-1.4.9-2.9.9-4.4,0-1.5-.3-3-.9-4.4h0ZM22.2,12c0,5.6-4.6,10.2-10.2,10.2S1.8,17.6,1.8,12,6.4,1.8,12,1.8s10.2,4.6,10.2,10.2h0Z" />
        <path d="M11.8,18.3c-.6,0-1.1-.5-1.1-1.1s.5-1.1,1.1-1.1,1.1.5,1.1,1.1-.5,1.1-1.1,1.1h0Z" />
        <path d="M13,13.8c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1v-7.9c0-.6.5-1.1,1.1-1.1s1.1.5,1.1,1.1v7.9Z" />
      </g>
    </SvgIcon>
  );
});

export default AppIconsError;
